// index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import Home from './pages/Home.tsx';
import Blog from './pages/blog.tsx'; // Use blog.tsx untuk kedua series
import SAFMCPART1 from './pages/blogDetail/safmc/safmcPart1.tsx';
import SAFMCPART2 from './pages/blogDetail/safmc/safmcPart2.tsx';
import SAFMCPART3 from './pages/blogDetail/safmc/safmcPart3.tsx';
import SAFMCPART4 from './pages/blogDetail/safmc/safmcPart4.tsx';
import SAFMCPART5 from './pages/blogDetail/safmc/safmcPart5.tsx';
import SAFMCPART6 from './pages/blogDetail/safmc/safmcPart6.tsx';
import SAFMCPART7 from './pages/blogDetail/safmc/safmcPart7.tsx';

import ACLPART1 from './pages/blogDetail/acl/aclPart1.tsx';
import ACLPART2 from './pages/blogDetail/acl/aclPart2.tsx';
import ACLPART3 from './pages/blogDetail/acl/aclPart3.tsx';
import ACLPART4 from './pages/blogDetail/acl/aclPart4.tsx';
import ACLPART5 from './pages/blogDetail/acl/aclPart5.tsx';
import ACLPART6 from './pages/blogDetail/acl/aclPart6.tsx';
import ACLPART7 from './pages/blogDetail/acl/aclPart7.tsx';
import ACLPART8 from './pages/blogDetail/acl/aclPart8.tsx';
import ACLPART9 from './pages/blogDetail/acl/aclPart9.tsx';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/safmc',
    element: <Blog />, // Sama-sama gunakan Blog component
  },
  {
    path: '/acl',
    element: <Blog />, // Sama-sama gunakan Blog component
  },
  {
    path: '/safmc/safmc-part1',
    element: <SAFMCPART1 />,
  },
  {
    path: '/safmc/safmc-part2',
    element: <SAFMCPART2 />,
  },
  {
    path: '/safmc/safmc-part3',
    element: <SAFMCPART3 />,
  },
  {
    path: '/safmc/safmc-part4',
    element: <SAFMCPART4 />,
  },
  {
    path: '/safmc/safmc-part5',
    element: <SAFMCPART5 />,
  },
  {
    path: '/safmc/safmc-part6',
    element: <SAFMCPART6 />,
  },
  {
    path: '/safmc/safmc-part7',
    element: <SAFMCPART7 />,
  },
  {
    path: '/acl/acl-part1',
    element: <ACLPART1 />,
  },
  {
    path: '/acl/acl-part2',
    element: <ACLPART2 />,
  },
  {
    path: '/acl/acl-part3',
    element: <ACLPART3 />,
  },
  {
    path: '/acl/acl-part4',
    element: <ACLPART4 />,
  },
  {
    path: '/acl/acl-part5',
    element: <ACLPART5 />,
  },
  {
    path: '/acl/acl-part6',
    element: <ACLPART6 />,
  },
  {
    path: '/acl/acl-part7',
    element: <ACLPART7 />,
  },
  {
    path: '/acl/acl-part8',
    element: <ACLPART8 />,
  },
  {
    path: '/acl/acl-part9',
    element: <ACLPART9 />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={router} />
);

reportWebVitals();
